export default __webpack_public_path__ + "static/media/ImgGift07.c38bdacf.jpg";